<template>
  <div class="thumbnail">
    <div v-if="image && image.url" class="thumbnail__image">
      <img :src="image.url" :alt="image.alt">
    </div>
    <div class="thumbnail__right">
      <Heading
        :label="label"
        :title="title"
        :subtitle="subtitle"
        :level="level"
        class="thumbnail__text"
      />
      <router-link class="thumbnail__link" :to="link">
        <component
          :is="icon"
          v-if="icon"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import * as components from '@/icons'
import Heading from '@/components/heading/Heading.vue'


export default {
  components: {
    ...components,
    Heading
  },
  props: {
    image: {
      type: Object,
      default: () => {}
    },
    label: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    level: {
      type: String,
      default: 'h5'
    },
    link: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'chevron-right'
    }
  }
}
</script>

<style lang="scss">
.thumbnail {
  position: relative;
  display: flex;
  align-items: $thumbnail-flex-align;
  padding: $thumbnail-padding;
  &__right {
    display: flex;
    align-items: $thumbnail-flex-align;
    flex-grow: 1;
  }
  &__text {
    margin: 0;
    padding: 0;
    flex-grow: 1;
    min-width: 180px;
    padding: 0 $thumbnail-text-padding;
    .heading__title {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    &.h1, &.h2, &.h3 {
      .heading__title {
        -webkit-line-clamp: 2;
      }
    }
  }
  &__image {
    flex-shrink: 0;
    width: $thumbnail-image-width;
    height: $thumbnail-image-height;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &__link {
    padding: $thumbnail-icon-padding;
    svg {
      width: $thumbnail-icon-width;
      width: $thumbnail-icon-height;
      height: 1rem;
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>


<docs>
  ```vue
  <Thumbnail :image="{url: 'https://picsum.photos/200/300', 'alt': 'Onboarding step 1'}" label="Thumbnail label" title="Thumbnail title" />
  ```
  ```scss
  // Variable defaults:
  $thumbnail-padding: rem(10) 0;
  $thumbnail-image-width: rem(90);
  $thumbnail-image-height: $thumbnail-image-width;
  $thumbnail-icon-width: $default-icon-width; // 1rem
  $thumbnail-icon-height: $default-icon-width; // 1rem
  $thumbnail-flex-align: center;
  $thumbnail-text-padding: $padding; // rem(15)
  $thumbnail-icon-padding: $padding; // rem(15)
  ```
</docs>
